import React, { useEffect } from "react";

export default function ErrorModal({
  open,
  message,
  title = "Something went wrong",
  onClose,
  autoCloseMs = 4000,
}) {
  useEffect(() => {
    if (!open) return undefined;

    const timer = window.setTimeout(() => {
      onClose?.();
    }, autoCloseMs);

    return () => {
      window.clearTimeout(timer);
    };
  }, [open, autoCloseMs, onClose]);

  if (!open || !message) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 px-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-description"
        className="w-full max-w-md rounded-3xl border border-red-500/20 bg-[#1c1c1c] p-6 shadow-[0_20px_80px_rgba(0,0,0,0.45)]"
      >
        <div className="flex items-start gap-4">
          <div className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-500/15">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-red-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v3m0 4h.01M10.29 3.86l-7.5 13A2 2 0 004.5 20h15a2 2 0 001.71-3.14l-7.5-13a2 2 0 00-3.42 0z"
              />
            </svg>
          </div>

          <div className="min-w-0 flex-1">
            <h3
              id="error-modal-title"
              className="text-xl font-semibold text-white"
            >
              {title}
            </h3>

            <p
              id="error-modal-description"
              className="mt-2 text-sm leading-6 text-white/75"
            >
              {message}
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full rounded-2xl bg-pink-500 px-5 py-3 font-semibold text-white transition hover:bg-pink-600"
        >
          OK
        </button>
      </div>
    </div>
  );
}